import type { AxiosRequestConfig } from 'axios'
import type { PendingMutation, MutationPayloadValue } from '@/types/logistics'

function appendFormValue(formData: FormData, key: string, value: MutationPayloadValue) {
  if (value === undefined || value === null) {
    return
  }

  if (Array.isArray(value)) {
    value.forEach((item) => appendFormValue(formData, `${key}[]`, item))
    return
  }

  if (value instanceof File) {
    formData.append(key, value, value.name)
    return
  }

  if (value instanceof Blob) {
    formData.append(key, value, key)
    return
  }

  formData.append(key, String(value))
}

export function mutationRequestConfig(mutation: PendingMutation): AxiosRequestConfig {
  if (mutation.encoding !== 'multipart') {
    return {
      url: mutation.endpoint,
      method: mutation.method,
      data: mutation.payload
    }
  }

  const formData = new FormData()

  Object.entries(mutation.payload).forEach(([key, value]) => {
    appendFormValue(formData, key, value)
  })

  return {
    url: mutation.endpoint,
    method: mutation.method,
    data: formData
  }
}
